import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Accesstokenjwt } from '../../../model/Accesstokenjwt';

@Injectable({
  providedIn: 'root'
})
export class JwtTokenEndPointService {

  header = new HttpHeaders(
    {'Access-Control-Allow-Origin' : '*',
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT'}
  );
  constructor(private httpclient:HttpClient) { }

  GenerateJwtToken(accesstokenjwt:Accesstokenjwt){
    return this.httpclient.post<any>(environment.backend_url+'GenerateJwtToken',accesstokenjwt,{ headers: this.header });
  }
}
